/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SMTPConfiguration
 */
export interface SMTPConfiguration {
    /**
     * 
     * @type {string}
     * @memberof SMTPConfiguration
     */
    fromAddress: string;
    /**
     * 
     * @type {string}
     * @memberof SMTPConfiguration
     */
    server: string;
    /**
     * 
     * @type {number}
     * @memberof SMTPConfiguration
     */
    port: number;
    /**
     * 
     * @type {string}
     * @memberof SMTPConfiguration
     */
    tls: string;
    /**
     * 
     * @type {string}
     * @memberof SMTPConfiguration
     */
    username: string | null;
    /**
     * 
     * @type {string}
     * @memberof SMTPConfiguration
     */
    password: string | null;
}

export function SMTPConfigurationFromJSON(json: any): SMTPConfiguration {
    return SMTPConfigurationFromJSONTyped(json, false);
}

export function SMTPConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SMTPConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fromAddress': json['from_address'],
        'server': json['server'],
        'port': json['port'],
        'tls': json['tls'],
        'username': json['username'],
        'password': json['password'],
    };
}

export function SMTPConfigurationToJSON(value?: SMTPConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from_address': value.fromAddress,
        'server': value.server,
        'port': value.port,
        'tls': value.tls,
        'username': value.username,
        'password': value.password,
    };
}


